import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Box,
  useTheme,
} from '@mui/material';
import {
  Menu as MenuIcon,
  ExitToApp as LogoutIcon,
} from '@mui/icons-material';
import { useAuth } from '../contexts/AuthContext.tsx';
import Navigation from './Navigation.tsx';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { logout, user } = useAuth();
  const [mobileOpen, setMobileOpen] = useState(false);
  const theme = useTheme();

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleLogout = () => {
    logout();
  };

  return (
    <Box sx={{ display: 'flex' }}>
      {/* Navigation Drawer */}
      <Navigation open={mobileOpen} onClose={handleDrawerToggle} />

      {/* App Bar - Full width */}
      <AppBar
        position="fixed"
        sx={{
          width: '100%',
          zIndex: theme.zIndex.drawer + 1,
        }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { md: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
          <Box component="img"
            src="https://postofficepub.com/pluto-images/funnel/images/895e4b46-ef31-46ac-ac60-cbaea5b7c68f?h=56&dpr=1&fit=cover"
            alt="Post Office Pub"
            sx={{ height: 40, mr: 2, display: 'block' }}
          />
          <Typography variant="h6" component="div" sx={{ flexGrow: 1, fontWeight: 700, fontSize: '1.5rem' }}>
            Post Office Pub
          </Typography>
          <Typography variant="body2" sx={{ mr: 2 }}>
            Welcome, {user?.email}
          </Typography>
          <IconButton color="inherit" onClick={handleLogout}>
            <LogoutIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      {/* Main Content */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          width: '100%',
          mt: '64px',
          minHeight: 'calc(100vh - 64px)',
          backgroundColor: 'grey.50',
          position: 'relative',
          zIndex: 1,
          pl: { md: '240px' }, // Add left padding to account for navigation
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default Layout;
